import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function PointOfContact({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));

    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!primaryDetails.full_name) {
      errors.full_name = true;
    }

    if (!primaryDetails.position) {
      errors.position = true;
    }

    if (!primaryDetails.mobile) {
      errors.mobile = true;
    }
    if (!primaryDetails.store_hours) {
      errors.store_hours = true;
    }


    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    return !!primaryDetails.full_name && !!primaryDetails.position && !!primaryDetails.mobile && !!primaryDetails.store_hours;
  };
  const handleNext = () => {
  if (!validateForm()) {
    toast.error("Please fill in all required fields.");
    return;
  }
  if (primaryDetails.merchant_type === "Maya Merchant") {
    navigation.go("handling-and-merchant-concerns");
  } else {
    navigation.go("non-maya-merchants-survey");
  }
};

  const handleBack = () => {
    navigation.previous();
  };

  const positions = [
    "Manager",
    "OIC",
    "Owner",
    "Supervisor",
    "Team Leader",
    "Other Position"
  ];



  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">
                POINT OF CONTACT (POC)
              </h4>
              <p className="form-desc">
                Please provide point of contact information
              </p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Full Name */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Point of contact (FULL NAME)
                      <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="full_name"
                      value={primaryDetails.full_name || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input ${isError.full_name ? 'form-input-error' : ''}`}
                    />
                    {isError.full_name && (
                      <div className="form-error">Full name is required.</div>
                    )}
                  </Form.Group>

                  {/* Position */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Point of contact (POSITION)
                      <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Select
                      name="position"
                      value={primaryDetails.position || ''}
                      onChange={handleInputChange}
                      className={`form-select${isError.position ? ' form-input-error' : ''}`}
                    >
                      <option value="">Select position</option>
                      {positions.map((position, index) => (
                        <option key={index} value={position}>
                          {position}
                        </option>
                      ))}
                    </Form.Select>
                    {isError.position && (
                      <div className="form-error">Position is required.</div>
                    )}
                  </Form.Group>

                  {/* Other Position */}
                  {primaryDetails.position === "Other Position" && (
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label">
                        Point of contact (OTHER POSITION)
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="other_position"
                        value={primaryDetails.other_position || ""}
                        onChange={handleInputChange}
                        placeholder="Short answer text"
                        className="form-input"
                      />
                    </Form.Group>
                  )}

                  {/* Mobile */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Point of contact (MOBILE)
                      <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile"
                      value={primaryDetails.mobile || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input ${isError.mobile ? 'form-input-error' : ''}`}
                    />
                    {isError.mobile && (
                      <div className="form-error">Mobile number is required.</div>
                    )}
                  </Form.Group>

                  {/* Landline */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Point of contact (LANDLINE)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="landline"
                      value={primaryDetails.landline || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Email */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Point of contact (EMAIL)
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={primaryDetails.email || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Store Hours */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Store Hours <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="store_hours"
                      value={primaryDetails.store_hours || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input ${isError.store_hours ? 'form-input-error' : ''}`}
                    />
                    {isError.store_hours && (
                      <div className="form-error">Store hours is required.</div>
                    )}
                  </Form.Group>

                  {/* Freebies */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Freebies Given
                    </Form.Label>
                    {/* <Form.Text className="form-hint">
                      List down freebies and given quantity (i.e. ballpen 2, notebook 2)
                    </Form.Text> */}
                    <Form.Control
                      type="text"
                      name="freebies"
                      value={primaryDetails.freebies || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                    <div>
                      <p className="form-note-text">
                        <em>"Note: List freebie then quantity, separate by comma."</em>
                      </p>
                    </div>
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PointOfContact;